import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Slices/ParamSlice";
import { useAppDispatch } from "../../Core/store.hooks";
import { Button } from "@progress/kendo-react-buttons";
import {
  updateDashboard,
  getDashboardExportSelector,
  getDashboardResetSelector,
} from "../Slices/DashboardSlice";
import { getSettingsSelector, updateSettings } from "../../Settings/Slice";
import { DropDownList } from "@progress/kendo-react-dropdowns";

interface IFilters {
  buttons?: any;
  exportHandler: any;
  resetHandler: any;
  saveDashboard: any;
    shareDashboard: any;
    manageDashboard: any;
  addWidget: any;
  addRemove?: boolean;
  savable?: boolean;
}

const Filters = (props: IFilters) => {
  const exportCounter = useSelector(getDashboardExportSelector);
  const resetCounter = useSelector(getDashboardResetSelector);
  const globalParams = useSelector(getParamsSelector);
  const settings = useSelector(getSettingsSelector);

  

  const dispatch = useAppDispatch();
  const exportDashboardHandler = () => {
    props.exportHandler();
  };
  const resetDashboardHandler = () => {
    props.resetHandler();
  };
  const addWidgetHandler = () => {
    props.addWidget();
  };
  const saveDashboardHandler = () => {
    props.saveDashboard();
  };
  const shareDashboardHandler = () => {
    props.shareDashboard();
  };
    const manageDashboardHandler = () => {
        props.manageDashboard();
    };
  const renderAddButton = () => {
    if (props.addRemove || props.addRemove == null) {
      return (
        <Fragment>
          <Button className=" pp-filter-button" onClick={addWidgetHandler}>
            Add Widgets
          </Button>
        </Fragment>
      );
    }
  };
    const renderShareButton = () => {
        if (props.savable || props.savable == null) {
            return (
                <Fragment>
                    <Button className=" pp-filter-button" onClick={shareDashboardHandler}>
                        Share Dashboard
                    </Button>
                </Fragment>
            );
        }
    };
  const renderSaveButton = () => {
    if (props.savable || props.savable == null) {
      return (
        <Fragment>
          <Button className=" pp-filter-button" onClick={saveDashboardHandler}>
            Save Dashboard
          </Button>
        </Fragment>
      );
    }
  };
    const renderManageButton = () => {
        return (
                <Fragment>
                    <Button className=" pp-filter-button" onClick={manageDashboardHandler}>
                        Manage Dashboards
                    </Button>
                </Fragment>
            );
        
    };
 
  function renderContent() {
    return (
      <Fragment>
        {props.buttons}
        {renderAddButton()}
        {renderSaveButton()}
        {renderManageButton()}
        <Button className=" pp-filter-button" onClick={resetDashboardHandler}>
          Reset Dashboard
        </Button>{" "}
            {renderShareButton() }
        <Button className=" pp-filter-button" onClick={exportDashboardHandler}>
          Export to PDF
        </Button>
      </Fragment>
    );
  }
  return <Fragment>{renderContent()}</Fragment>;
};

export default Filters;
